export const SOURCE_TYPE_DISPLAY_VALUE = {
	csv: 'CSV',
	file_csv: 'CSV',
	file_xlsx: 'XLSX',
	gsheet: 'Google Spreadsheet',
	json: 'JSON',
	xml: 'XML',
};

export function buildContentFeedUrl({ format, url, itemKey }) {
	if (format === 'gsheet') {
		return `https://docs.google.com/spreadsheets/d/${url}/?gid=${itemKey}`;
	}
	return url;
}
